<template>
  <span
    v-if="state.isMappableValue"
    :class="{
      barLabel: true,
      'barLabel--primary': state.value === 'complete',
      'barLabel--secondary': state.value === 'inProgress',
      'barLabel--pale': state.value === 'notStarted',
    }"
    >{{ input }}</span
  >
  <template v-else>
    <span v-html="markdown.renderInline(input)"></span>
  </template>
</template>

<script setup>
import markdownit from "markdown-it";
import { onMounted, reactive, ref, watch } from "vue";

const props = defineProps({
  input: {
    type: String,
  },
});

const state = reactive({
  isMappableValue: false,
  value: props.input,
  randomId: +new Date(),
});
const map = {
  complete: ["complete", "completed"],
  inProgress: ["in progress"],
  notStarted: ["not yet started", "not started"],
};
const markdown = markdownit();

//lifecycle
onMounted(() => {
  assignValue();
});

//methods
const assignValue = function () {
  let value = props.input.toLowerCase();
  for (let key in map) {
    if (map[key].includes(value)) {
      state.isMappableValue = true;
      state.value = key;
      return;
    }
  }
};
</script>

<style scoped></style>
